import React, { Component } from "react";
import {
  Table,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableBody,
  TableRowColumn,
} from "material-ui/Table";
import ArrowDown from "material-ui/svg-icons/navigation/arrow-drop-down";
import ArrowUp from "material-ui/svg-icons/navigation/arrow-drop-up";
import Page from "../framework/Page/Page";
import Industry from "./Industry";

const styles = {
  tableHeaderStyle: {
    border: "none",
    background: "#F5F5F5",
    fontSize: "16px",
  },
  arrowStyle: {
    position: "absolute",
    top: "10px",
  },
  tableHeaderColumn: {
    height: "55px",
    color: "#000",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "16px",
    paddingLeft: "20px",
    paddingRight: "20px",
  },
  tableHeaderSortedColumn: {
    height: "55px",
    color: "#000",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "16px",
    backgroundColor: "#E3E3E3",
    paddingLeft: "20px",
    paddingRight: "20px",
    backgroundClip: "padding-box",
  },
  tableRowColumn: {
    position: "relative",
    paddingLeft: "20px",
    paddingRight: "20px",
    height: "55px",
    fontSize: "16px",
  },
  settingStyle: {
    position: "absolute",
    right: "6em",
    top: "0.9em",
    cursor: "pointer",
  },
};

class ClientsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestParams: {
        pageNumber: 1,
        pageSize: 10,
        sortColumn: "name", //support name , role, email, status field
        order: "desc", // asc or desc
        keyword: "", // optional
      },
      requestInvitationClientParams: {
        roleId: "",
        title: "",
        firstName: "",
        lastName: "",
        email: "",
        companyName: "",
        industryId: "",
        subscriptionTierId: "",
        accountNumber: "",
        accountManagerUserIds: [""],
      },
    };
  }
  componentDidMount() {
    this.props.getClientsTable(this.state.requestParams);
    this.props.getAllClientsTable({
      pageNumber: 1,
      pageSize: 9999,
      sortColumn: "name", //support name , role, email, status field
      order: "desc", // asc or desc
      keyword: "", // optional
    });
  }
  componentWillReceiveProps(nextProps) {}
  // below is callback for page component
  nextBeClick(page) {
    this.dispatchPageAction(page);
  }
  nextGroupBeClick(page) {
    this.dispatchPageAction(page);
  }
  previousGroupBeClick(page) {
    this.dispatchPageAction(page);
  }
  previousBeClick(page) {
    this.dispatchPageAction(page);
  }
  pageBeClick(page) {
    this.dispatchPageAction(page);
  }
  selectRows(page, row) {
    this.setState(
      {
        requestParams: {
          ...this.state.requestParams,
          pageSize: row,
        },
      },
      () => {
        this.dispatchPageAction(page);
      },
    );
  }
  goToPage(page) {
    if (page > this.props.tableData.pageCount) {
      return;
    } else {
      this.dispatchPageAction(page);
    }
  }
  dispatchPageAction(page) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        pageNumber: page,
      },
    });
    this.props.getClientsTable({
      pageNumber: page,
      pageSize: this.state.requestParams.pageSize,
      sortColumn: this.state.requestParams.sortColumn, //support name , role, email, status field
      order: this.state.requestParams.order, // asc or desc
    });
  }
  handleHeaderClick(e) {
    this.setState({
      cache_sortColumn: e.target.innerText,
    });
    const params = {
      order:
        this.state.requestParams.order === "desc" &&
        this.state.cache_sortColumn === e.target.innerText
          ? "asc"
          : "desc",
      sortColumn: "name",
    };

    switch (e.target.innerText) {
      case "Client Name":
        params.sortColumn = "name";
        break;
      case "Industry Type":
        params.sortColumn = "industry";
        break;
      case "Status":
        params.sortColumn = "status";
        break;
      case "Subscription Tier":
        params.sortColumn = "tier";
        break;
      case "Business Unit Name":
        params.sortColumn = "name";
        break;
      default:
        return;
    }
    this.setState(
      {
        requestParams: {
          order: params.order,
          sortColumn: params.sortColumn,
        },
      },
      () => {
        this.props.getClientsTable(this.state.requestParams);
      },
    );
  }
  handleSearch(keyword, industryId) {
    if (keyword !== "") {
      this.setState(
        {
          requestParams: {
            ...this.state.requestParams,
            pageNumber: 1,
          },
        },
        () => {
          this.props.search_clients({
            ...this.state.requestParams,
            industryId: industryId.value,
            keyword,
          });
        },
      );
    } else if (keyword === "") {
      this.setState(
        {
          pageNumber: 1,
          pageSize: 10,
          sortColumn: "name", //support name , role, email, status field
          order: "desc", // asc or desc
          keyword: "", // optional
        },
        () => {
          this.props.search_clients(this.state.requestParams);
        },
      );
    }
  }
  handleIconClick(targetName) {
    const params = {
      order: this.state.requestParams.order === "desc" ? "asc" : "desc",
      sortColumn: "name",
    };

    switch (targetName) {
      case "Client Name":
        params.sortColumn = "name";
        break;
      case "Industry Type":
        params.sortColumn = "industry";
        break;
      case "Status":
        params.sortColumn = "status";
        break;
      case "Subscription Tier":
        params.sortColumn = "tier";
        break;
      default:
        return;
    }

    this.setState(
      {
        requestParams: {
          order: params.order,
          sortColumn: params.sortColumn,
        },
      },
      () => {
        this.props.getClientsTable(this.state.requestParams);
      },
    );
  }
  render() {
    const isClientAdmin = /^(account manager|administrator|team member|system administrator)/gi.test(
      this.props.roleName,
    );
    const nameTitle = /^(account manager|system administrator)/gi.test(
      this.props.roleName,
    )
      ? "Client Name"
      : "Business Unit Name";
    return (
      <div className="clients-table-wrapper">
        {/*for item and search bar*/}
        <div className="industry-wrapper clearfix">
          <Industry
            style={{ float: "left" }}
            getIndustryOptions={this.props.getIndustryOptions}
            industryOptions={this.props.industryOptions}
            roleName={this.props.roleName}
            tableAllData={this.props.tableAllData}
            handleSearch={(keyword, industryId) =>
              this.handleSearch(keyword, industryId)
            }
          />
        </div>
        {/*end*/}
        <div className="clients-table" onClick={e => this.handleHeaderClick(e)}>
          {// no data
          this.props.tableData === "empty" && (
            <section>
              <p>You have not invited any clients.</p>
              <p>Send an invite to a client for platform access.</p>
            </section>
          )}
          {typeof this.props.tableData === "object" && (
            <Table style={{ fontFamily: "Arial" }}>
              <TableHeader
                displaySelectAll={false}
                style={styles.tableHeaderStyle}
                adjustForCheckbox={false}
              >
                <TableRow
                  displayBorder={false}
                  style={{ height: "55px", fontSize: "16px" }}
                >
                  {[
                    { name: nameTitle, value: "name" },
                    { name: "Industry Type", value: "industry" },
                    { name: "Status", value: "status" },
                    { name: "Subscription Tier", value: "tier" },
                  ].map((item, index) => {
                    if (index === 2) {
                      return (
                        <TableHeaderColumn
                          style={{
                            ...(this.state.requestParams.sortColumn ===
                            item.value
                              ? styles.tableHeaderSortedColumn
                              : styles.tableHeaderColumn),
                          }}
                          key={index}
                        >
                          {item.name}
                          {/*<ArrowDown style={{ display: this.state.requestParams.sortColumn !== item.value && (item.value !== "") ? 'inline-block' : 'none', position: 'absolute', top: '0.4em' }} />*/}
                          <ArrowDown
                            onClick={() => this.handleIconClick(item.name)}
                            data-value={item.name}
                            style={{
                              display:
                                this.state.requestParams.order === "desc" &&
                                this.state.requestParams.sortColumn ===
                                  item.value
                                  ? "inline-block"
                                  : "none",
                              position: "absolute",
                              top: "10px",
                              right: "0",
                            }}
                          />
                          <ArrowUp
                            onClick={() => this.handleIconClick(item.name)}
                            style={{
                              display:
                                this.state.requestParams.order === "asc" &&
                                this.state.requestParams.sortColumn ===
                                  item.value
                                  ? "inline-block"
                                  : "none",
                              position: "absolute",
                              top: "10px",
                              right: "0",
                            }}
                          />
                        </TableHeaderColumn>
                      );
                    }
                    if (index === 0) {
                      return (
                        <TableHeaderColumn
                          style={{
                            ...(this.state.requestParams.sortColumn ===
                            item.value
                              ? styles.tableHeaderSortedColumn
                              : styles.tableHeaderColumn),
                            width: "30%",
                          }}
                          key={index}
                        >
                          {item.name}
                          {/*<ArrowDown style={{ display: this.state.requestParams.sortColumn !== item.value && (item.value !== "") ? 'inline-block' : 'none', position: 'absolute', top: '0.4em' }} />*/}
                          <ArrowDown
                            onClick={() => this.handleIconClick(item.name)}
                            data-value={item.name}
                            style={{
                              display:
                                this.state.requestParams.order === "desc" &&
                                this.state.requestParams.sortColumn ===
                                  item.value
                                  ? "inline-block"
                                  : "none",
                              position: "absolute",
                              top: "10px",
                              right: "0",
                            }}
                          />
                          <ArrowUp
                            onClick={() => this.handleIconClick(item.name)}
                            style={{
                              display:
                                this.state.requestParams.order === "asc" &&
                                this.state.requestParams.sortColumn ===
                                  item.value
                                  ? "inline-block"
                                  : "none",
                              position: "absolute",
                              top: "10px",
                              right: "0",
                            }}
                          />
                        </TableHeaderColumn>
                      );
                    }
                    if (index === 1) {
                      return (
                        <TableHeaderColumn
                          style={{
                            ...(this.state.requestParams.sortColumn ===
                            item.value
                              ? styles.tableHeaderSortedColumn
                              : styles.tableHeaderColumn),
                            width: "35%",
                          }}
                          key={index}
                        >
                          {item.name}
                          {/*<ArrowDown style={{ display: this.state.requestParams.sortColumn !== item.value && (item.value !== "") ? 'inline-block' : 'none', position: 'absolute', top: '0.4em' }} />*/}
                          <ArrowDown
                            onClick={() => this.handleIconClick(item.name)}
                            data-value={item.name}
                            style={{
                              display:
                                this.state.requestParams.order === "desc" &&
                                this.state.requestParams.sortColumn ===
                                  item.value
                                  ? "inline-block"
                                  : "none",
                              position: "absolute",
                              top: "10px",
                              right: "0",
                            }}
                          />
                          <ArrowUp
                            onClick={() => this.handleIconClick(item.name)}
                            style={{
                              display:
                                this.state.requestParams.order === "asc" &&
                                this.state.requestParams.sortColumn ===
                                  item.value
                                  ? "inline-block"
                                  : "none",
                              position: "absolute",
                              top: "10px",
                              right: "0",
                            }}
                          />
                        </TableHeaderColumn>
                      );
                    } else {
                      return (
                        <TableHeaderColumn
                          style={{
                            ...(this.state.requestParams.sortColumn ===
                            item.value
                              ? styles.tableHeaderSortedColumn
                              : styles.tableHeaderColumn),
                          }}
                          key={index}
                        >
                          {item.name}
                          {/*<ArrowDown style={{ display: this.state.requestParams.sortColumn !== item.value && (item.value !== "") ? 'inline-block' : 'none', position: 'absolute', top: '0.4em' }} />*/}
                          <ArrowDown
                            onClick={() => this.handleIconClick(item.name)}
                            data-value={item.name}
                            style={{
                              display:
                                this.state.requestParams.order === "desc" &&
                                this.state.requestParams.sortColumn ===
                                  item.value
                                  ? "inline-block"
                                  : "none",
                              position: "absolute",
                              top: "10px",
                              right: "0",
                            }}
                          />
                          <ArrowUp
                            onClick={() => this.handleIconClick(item.name)}
                            style={{
                              display:
                                this.state.requestParams.order === "asc" &&
                                this.state.requestParams.sortColumn ===
                                  item.value
                                  ? "inline-block"
                                  : "none",
                              position: "absolute",
                              top: "10px",
                              right: "0",
                            }}
                          />
                        </TableHeaderColumn>
                      );
                    }
                  })}
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false}>
                {this.props.tableData.data.map((item, index) => (
                  <TableRow
                    selectable={false}
                    key={item.id}
                    style={{
                      height: "55px",
                      fontSize: "16px",
                      borderBottom: "solid 1px #e8ebef",
                    }}
                  >
                    <TableRowColumn
                      style={{
                        ...styles.tableRowColumn,
                        color: "#0997F7",
                        cursor: "pointer",
                        width: "30%",
                      }}
                    >
                      <span>
                        {isClientAdmin ? (
                          <a
                            href={`/clients/edit/Client-Profile/${
                              item.id
                            }?name=${item.name}`}
                          >
                            {item.name}
                          </a>
                        ) : (
                          item.name
                        )}
                      </span>
                    </TableRowColumn>
                    <TableRowColumn
                      style={{ ...styles.tableRowColumn, width: "35%" }}
                    >
                      {item.industry.name}
                    </TableRowColumn>
                    {/*<TableRowColumn>*/}
                    {/*{item.subscription.name}*/}
                    {/*</TableRowColumn>*/}
                    <TableRowColumn style={{ ...styles.tableRowColumn }}>
                      {item.status}
                    </TableRowColumn>
                    <TableRowColumn style={styles.tableRowColumn}>
                      {item.subscription && item.subscription.name}
                    </TableRowColumn>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
          <Page
            nextBeClick={page => this.nextBeClick(page)}
            pageCount={this.props.tableData.pageCount}
            pageSize={this.props.tableData.pageSize}
            nextGroupBeClick={page => this.nextGroupBeClick(page)}
            previousGroupBeClick={page => this.previousGroupBeClick(page)}
            previousBeClick={page => this.previousBeClick(page)}
            pageBeClick={page => this.pageBeClick(page)}
            total={this.props.tableData.total}
            hasNext={this.props.tableData.hasNext}
            hasPrevious={this.props.tableData.hasPrevious}
            pagePlus={true}
            selectRows={(page, row) => this.selectRows(page, row)}
            goToPage={page => this.goToPage(page)}
          />
        </div>
      </div>
    );
  }
}

export default ClientsTable;



// WEBPACK FOOTER //
// ./src/components/Clients/ClientsTable.jsx